import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, formatApiError, useAuth, setStoredToken } from "../AuthContext";
import AppHeader from "../components/AppHeader";
import SiteFooter from "../components/SiteFooter";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const token = searchParams.get("token") || "";

  useEffect(() => {
    if (!token) setError("Missing reset token. Request a new link.");
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    if (password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(true);
      if (data.token) setStoredToken(data.token);
      if (data.user) setUser(data.user);
      setTimeout(() => navigate("/app", { replace: true }), 1400);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Could not reset password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page" data-testid="reset-page">
      <div className="grain-bg" />
      <div className="container-narrow">
        <AppHeader />
        <div className="fade-in" style={{ maxWidth: 420, margin: "0 auto" }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Reset</div>
          <h1 className="display">Set a new password.</h1>

          {success ? (
            <div data-testid="reset-success" className="serif-italic" style={{ fontSize: 18, color: "var(--accent)", lineHeight: 1.6 }}>
              Done. Signing you in...
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="form-stack" data-testid="reset-form">
              <div>
                <label className="field-label" htmlFor="password">New password</label>
                <input
                  id="password" type="password" required minLength={6}
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  className="input-line" placeholder="At least 6 characters"
                  data-testid="reset-password-input" autoComplete="new-password"
                />
              </div>
              <div>
                <label className="field-label" htmlFor="confirm">Confirm</label>
                <input
                  id="confirm" type="password" required minLength={6}
                  value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  className="input-line" placeholder="Type it again"
                  data-testid="reset-confirm-input" autoComplete="new-password"
                />
              </div>
              {error && <div className="error-msg" data-testid="reset-error">{error}</div>}
              <div style={{ paddingTop: 8 }}>
                <button type="submit" className="btn-underline" disabled={loading || !token} data-testid="reset-submit-btn">
                  {loading ? "Saving…" : "Save new password →"}
                </button>
              </div>
              <div style={{ paddingTop: 16 }}>
                <Link to="/login" className="nav-link">← Back to sign in</Link>
              </div>
            </form>
          )}
        </div>
        <SiteFooter />
      </div>
    </div>
  );
}
